export const BUILD_INFO_CONST = {
  time: '2026-11-04T12:47:51.575Z',
  commit: 'eb192e37',
  branch: 'develop',
  tag: 'unknown',
};
